import React  from 'react';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { Link } from 'react-router-dom';

export const Portfolio = (props) => {
 
    const {t} = useTranslation()

        return (
          <section id="portfolio" className="portfolio dashboard-portfolio">
            <div className="container" data-aos="fade-up">
      
              <div className="dashboard-section-head">
                <div>
                  <span className="dashboard-kicker">Realisations</span>
                  <h2>{ t("blog.title")}</h2>
                </div>
                <p>
                  Une selection de contenus recents pour montrer le rythme, le traitement visuel
                  et la variete des sujets portes par B-eye.
                </p>
                </div>
      
              <div className="portfolio-isotope" data-portfolio-filter="*" data-portfolio-layout="masonry" data-portfolio-sort="original-order" data-aos="fade-up" data-aos-delay="100">
      
                <div>
                  <ul className="portfolio-flters">
                    <li data-filter="*" className="filter-active">Liste</li>
                    {
                      props.categories.map((category) => {
                        return(
                          <li key={ category.id } data-filter={"." + category.id }>{ category.name }</li>
                        )
                      })
                    }
                    
                  </ul>
                </div>
      
                <div className="row gy-4 portfolio-container">
                    {
                      props.articles.map((article, index) =>{
                        const image = article.images?.[0]?.image || article.images?.image || "/img/background.png";
                        const categoryId = article.category?.id || "";
                        return(
                          <div className={(index === 0 ? "col-xl-6 col-md-8 " : "col-xl-3 col-md-4 ") + "portfolio-item " + categoryId } key={ article.id }>
                            <div className="portfolio-wrap">
                              <Link to={ "/articles/" + article.id } data-gallery="portfolio-gallery-app" className="glightbox"><img src={ image } className="img-fluid" alt={ article.title }  style={{ top: 0, left: 0, width: '100%', zIndex: -1 }} /></Link>
                              <div className="portfolio-info">
                                <h4><Link to={"/articles/" + article.id} title={ article.category?.name } className=""><i className={ article.category?.icone }></i> { article.category?.name }</Link></h4>
                                <p className=''><Link to={ "/articles/" + article.id } className="text-dark">{ article.title }</Link></p>
                                <Link to={ "/articles/" + article.id } className="dashboard-card-link">Voir le projet <i className="bi bi-arrow-up-right"></i></Link>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  
                </div>
      
              </div>
      
            </div>
          </section>
        );
    }
